import { Component, Input, Output } from '@angular/core';
import { AssignedRole } from 'src/app/models/data/assignedRole';
import { EventEmitter } from '@angular/core';
import { MatDivider, MatListItem } from '@angular/material/list';
import { MatIcon } from '@angular/material/icon';

@Component({
	selector: 'app-active-role-item',
	templateUrl: 'login-select-role-item.component.html',
	styleUrls: ['../../login.component.scss', '../../../common/main.scss'],
	imports: [MatDivider, MatListItem, MatIcon],
})
export class LoginSelectRoleItemComponent {
	@Output() roleSelected = new EventEmitter();
	@Input() assignedRole!: AssignedRole;

	constructor() {}
}
